import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import MainHeader from "./MainHeader";
import Footer from "./Footer";

import Home from "./Home";
import About from "./About";
import Contact from './Contact';
import MernStack from './MernStack';
import MeanStack from './MeanStack';
import PHPStack from './PHPStack';

export default function App() {
  return (
    <Router>
      <MainHeader />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/mern-stack" element={<MernStack />} />
          <Route path="/mean-stack" element={<MeanStack />} />
          <Route path="/php-stack" element={<PHPStack />} />

        </Routes>
      </main>
     <Footer />
    </Router>
  );
}
